import React, { useRef, useState } from 'react';

const UploadBox = ({
  label = 'Upload Image',
  onChange,
  value = null,
  accept = 'image/*',
  style = {},
  className = '',
  ...props
}) => {
  const inputRef = useRef();
  const [dragActive, setDragActive] = useState(false);
  const [preview, setPreview] = useState(value ? (typeof value === 'string' ? value : URL.createObjectURL(value)) : null);

  const handleFile = (file) => {
    if (!file) return;
    setPreview(URL.createObjectURL(file));
    if (onChange) onChange(file);
  };

  const handleChange = (e) => {
    const file = e.target.files && e.target.files[0];
    handleFile(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    const file = e.dataTransfer.files && e.dataTransfer.files[0];
    handleFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  return (
    <div
      className={`liquid-glass-upload-box ${className}`}
      style={{
        position: 'relative',
        borderRadius: '16px',
        background: 'linear-gradient(135deg, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0.06) 50%, rgba(255,255,255,0.12) 100%)',
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        border: dragActive ? '2px solid #4facfe' : '2px solid rgba(255,255,255,0.18)',
        padding: '32px',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'border 0.2s',
        minHeight: '180px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        ...style
      }}
      onClick={() => inputRef.current && inputRef.current.click()}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      {...props}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        style={{ display: 'none' }}
        onChange={handleChange}
      />
      {preview ? (
        <img
          src={preview}
          alt="Preview"
          style={{
            maxWidth: '100%',
            maxHeight: '120px',
            borderRadius: '12px',
            marginBottom: '16px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
          }}
        />
      ) : (
        <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.1rem', marginBottom: 8 }}>{label}</div>
      )}
      <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.95rem' }}>
        Click or drag & drop to upload
      </div>
    </div>
  );
};

export default UploadBox; 